<template>
  <div class="c-overlay">
    <div class="c-overlay__body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'c-overlay',
}
</script>

<style lang="scss">
  .c-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;

    &__body {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      overflow: hidden;
    }
  }
</style>
